<div class="fp-dialog">
  <div class="fp-bar"></div>

  <div class="fp-header">
    <div class="fp-icon">
      <mat-icon>email</mat-icon>
    </div>
    <div class="fp-heading">
      <h2 class="fp-title">Forgot Password</h2>
      <p class="fp-sub">We'll send a reset link to your inbox</p>
    </div>
    <button class="fp-close" (click)="dialogRef.close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="fp-body">
    <form [formGroup]="forgotEmail" (ngSubmit)="onSubmit()">
      <mat-form-field class="fp-field"
                      color="warn"
                      appearance="outline"
                      subscriptSizing="dynamic">
        <mat-label>Email address</mat-label>
        <input matInput
               required
               type="email"
               formControlName="email"
               autocomplete="email">
        <mat-error *ngIf="emailHasError()">{{ getErrorMessage() }}</mat-error>
      </mat-form-field>

      <button class="fp-submit"
              type="button"
              [disabled]="forgotEmail.controls.email.invalid || loading"
              (click)="onSubmit()">
        <mat-icon>send</mat-icon>
        <span>Send Reset Link</span>
      </button>
    </form>
  </div>
</div>
